import { render, staticRenderFns } from "./candidatosResultadosSegunda.vue?vue&type=template&id=a1c5be34&"
import script from "./candidatosResultadosSegunda.vue?vue&type=script&lang=js&"
export * from "./candidatosResultadosSegunda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports